




































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { BotState } from '@/types';

import { formatPercent } from '@/shared/formatters';

const ftbot = namespace('ftbot');

@Component({})
export default class BotStatus extends Vue {
  @ftbot.State version;

  @ftbot.State profit;

  @ftbot.State botState?: BotState;

  formatPercent = formatPercent;

  formatTimestamp(timestamp) {
    return new Date(timestamp).toUTCString();
  }
}
